module.exports = __webpack_public_path__ + "img/breathing.d53da408.png";